import { z } from "zod"

/** Every entity id is a UUID v7 string, generated by the database or the service that owns the row. */
export const Id = z.uuid()
export type Id = z.infer<typeof Id>

export const WorkspaceId = Id.brand<"WorkspaceId">()
export type WorkspaceId = z.infer<typeof WorkspaceId>
